module.exports = __webpack_public_path__ + "static/media/60fd8e329c6d761545c4dbd9a9e10731@2x.278284cb.png";